import React from "react";
import Header from "../../shared/components/header";
import Footer from "../../shared/components/footer";
import ButtonV2 from "../../shared/components/buttonV2";
import {
  ALL_LOGO,
  ANAMBRA_LOGO,
  BACKGROUND,
  BLUERAY,
  ORANGE_BG,
  UI,
} from "../../utils-func/image_exports";
import Features from "./UIs/features";
import HowItWorks from "./UIs/howitworks";
import Testimonials from "./UIs/testimonials";
import Faqs from "./UIs/faqs";
import WorkFlows from "./UIs/workflows";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Bounce } from "react-awesome-reveal";
import { Store } from "../../states/store";

function LandingPage() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div
        className="lg:h-[700px] h-[450px] relative z-10 w-full bg-[#FFFCF6] flex items-center py-5 flex-col gap-y-4 justify-start lg:px-10 px-5"
        // style={{
        //   backgroundImage: `url(${BACKGROUND})`,
        // }}
      >
        <img
          src={ANAMBRA_LOGO}
          className="w-[190px] h-[160px] object-contain fixed left-7"
          alt=""
        />
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut", delay: 0.2 }}
          viewport={{ once: true }}
          className="lg:text-[64px] text-[35px] lg:leading-[60px] leading-[40px] text-center font-semibold text-[#1A1915]"
        >
          {/* AI-Powered Case <br /> Management for Judges */}
          AI-Powered Assistant <br /> for Anambra State <br /> Judges.
        </motion.span>
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          viewport={{ once: true }}
          className="lg:text-xl text-sm font-normal text-[#383838] text-center"
        >
          Discover intelligent tools that simplify your <br /> workload and
          enhance your decision-making
        </motion.span>
        <Bounce duration={1500}>
          <ButtonV2
            title={"Get Started Today"}
            btnStyle={"bg-black rounded-xl py-4 w-[218.82px] h-[60.37px]"}
            textStyle={"text-white font-semibold"}
            handleClick={() => navigate("/sign-up", { replace: true })}
          />
        </Bounce>
        {/* 
        <img
          src={BLUERAY}
          className="w-[747px] h-[747px] absolute left-0 lg:-top-16 -top-[11rem] lg:z-0 -z-10"
          alt=""
        />
        <img
          src={BLUERAY}
          className="w-[747px] h-[747px] absolute right-0 scale-x-[-1] lg:-top-16 -top-[11rem] lg:z-0 -z-10"
          alt=""
        /> */}
        <motion.img
          initial={{ rotateX: -90, opacity: 0 }}
          whileInView={{ rotateX: 0, opacity: 1 }}
          transition={{ duration: 2, ease: "easeInOut" }}
          viewport={{ once: true }}
          src={ORANGE_BG}
          className="lg:w-[1154px] w-[335px] h-[718px] object-contain absolute lg:top-96 top-24 -z-10"
          alt=""
        />
      </div>
      <div className="lg:mt-[30rem] lg:px-0 px-8 mt-[11rem] flex items-center justify-center flex-col">
        <span className="lg:text-xl text-lg text-center font-semibold text-[#C4C4C4]">
          Trusted By Well-known Public and Private Legal Firms
        </span>
        <img
          src={ALL_LOGO}
          className="w-full h-[115.36px] object-contain"
          alt=""
        />
      </div>
      <div>
        <Features />
        <HowItWorks />
        {/* <Testimonials /> */}
        {/* <Faqs /> */}
        <WorkFlows />
      </div>
      <Footer />
    </>
  );
}

export default LandingPage;
